import { tasks_v1 } from "@googleapis/tasks";
import { IAccount } from "@/types";

// Task editing mode enum
export enum TaskEditMode {
  None = "NONE",
  New = "NEW",
  Existing = "EXISTING"
}

// Task editing state interface
export interface TaskEditState {
  mode: TaskEditMode;
  taskId?: string;
}

export type ExtendedTask = tasks_v1.Schema$Task & {
  accountId: string;
  tasklistId: string;
}

export type ExtendedTaskList = tasks_v1.Schema$TaskList & {
  accountId: string;
}

export type ExtendedMoveTaskParams = tasks_v1.Params$Resource$Tasks$Move & {
  account: IAccount;
  taskId: string;
}

// Common task item props
export interface TaskItemProps {
  task: ExtendedTask;
  list: string;
  account: IAccount;
  variant: "completed" | "needsAction";
  onEdit: (taskId: string) => void;
}

// Task input props
export interface TaskInputProps {
  listId: string;
  account: IAccount;
  task?: ExtendedTask;
  onClose: () => void;
  onSubmit: (task: Partial<ExtendedTask>, submissionMethod?: 'enter' | 'clickOutside' | 'datePicker') => void;
}

// DatePicker props
export interface DatePickerProps {
  date: Date | null;
  setDate: (date: Date | null) => void;
  onOk: (date: Date | null) => void;
  onOpenChange?: (isOpen: boolean) => void;
}

// Sort types
export type TaskSortType = "position" | "dueDate" | "alphabetical"; 

export type OptimisticUpdatedLists = {
  updatedSourceList?: ExtendedTask[];
  updatedDestinationList?: ExtendedTask[];
}

export type FilterTypes = "search" | "upcoming" | "past" | "needsDate";